import { apiNotificationsProvider } from "./apiNotificationsProvider";
import { mockNotificationsProvider } from "./mockNotificationsProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const notificationsProvider = isMockEnabled("notifiche")
  ? mockNotificationsProvider
  : apiNotificationsProvider;
